export default ({
  pageState: { editorBlocks },
  data: {
    blockData,
    blockId,
    blockType,
    editor,
    missingTranslations,
    order,
    updatedAt
  }
}) => {
  return {
    editorBlocks: {
      ...editorBlocks,
      [blockId]: {
        data: blockData,
        editor,
        isNew: true,
        missingTranslations,
        type: blockType,
        updatedAt
      }
    },
    editorBlocksOrder: order,
    editorHeaderStatus: 'saved',
    editorHeaderUpdatedAt: updatedAt,
    editorIsDraft: true
  };
};
